<!--
 * @Author: 缺省页
 * @Date: 2020-07-23 15:55:34
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 15:23:23
 * @FilePath: \car-demo\src\views\Empty.vue
-->
<template>
<div class="container">
	<div class="empty">
		<div class="text-center">
			<img src="../assets/images/empty.png" alt="这里空空如也" />
			<p class="description">{{error}}</p>
		</div>
	</div>
</div>
</template>

<script>
export default {
	data(){
		return {
			error:'这里空空如也~',
		}
	},
	created() {
		var error = this.$route.query.error;
		if(error){this.error = error}
	}
}
</script>

<style scoped lang="less">
.empty {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100vh;
    background-color: #f8f8f8;
    text-align: center;
	.description {
		color: #999999;
		font-size: 14px;
		margin-top: 10px;
	}
}
</style>
